import React, {useContext, useEffect, useState} from "react";
import {OrderContext} from "../../context/OrderContext";
import Tasks from "../tasks/tasksList" ;

import OrderUploadBidHandler from "./files/orderUploadCustomFolderHandler";
import {FileContext} from "../../context/FileContext";
import {IoIosArrowDown  , IoIosArrowForward  } from "react-icons/io";


export default function OrderInReview(id) {
    const {order} = useContext(OrderContext);
    const [isOpen, setIsOpen] = useState(order?.reviewDetails?.sort((a, b) => Number(b.version) - Number(a.version))?.[0]?.["version"]);
    const orderEdit = false;

    const toggleAccordion = (version) => {
        setIsOpen(version);
    };


    const getDatesField = (text) => {

        if(typeof text === "undefined" || text === "-") {return;}

        text = new Date(Number(text));
        text = text?.toLocaleString("de-DE", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        })


        return text+" Uhr";
    };

    useEffect(() => {
        if (order?.stage === "inDevelopment") {
            for (var a = 0; a < order?.reviewDetails?.length; a++){
                if(order.reviewDetails[a].status === "active") {
                    order.reviewDetails[a].status = "archived";
                }
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    return (
        <div className={"border border-gray-500 rounded-lg divide-y bg-white divide-gray-300 overflow-hidden text-left mb-2 sm:mb-4 md:mb-8"}>
            <div>
                <div className="lg:px-6 px-4 py-4 sm:px-0 ">
                    <h3 className="text-lg  font-semibold text-gray-900">Auftragsabnahme</h3>
                </div>
                <div>
                    {(typeof order?.reviewDetails !== "undefined") && (
                        <div>
                            {order?.reviewDetails?.sort((a, b) => Number(b.version) - Number(a.version))?.map((element, key) => {
                                return (
                                    <div className={"border-t border-gray-400 lg:px-6 px-4 py-4"} key={key}>
                                        <div className="flex items-center  w-full  text-lg font-semibold text-gray-900 accordion-header cursor-pointer" onClick={() => {(isOpen !== element?.version) ? toggleAccordion(element?.version) : toggleAccordion(null)}}>
                                            {(isOpen === element?.version ) ? (
                                                <span><IoIosArrowDown  className={"mr-2 h-4 w-4 cursor-pointer"} /></span>
                                            ):(
                                                <span><IoIosArrowForward  className={"mr-2 h-4 w-4 cursor-pointer"} /></span>
                                            )}

                                            {(order.stage === "completed" && element?.status === "active") ? (
                                                <h4 className=" block text-base font-bold text-gray-900">
                                                    Version {element?.version}
                                                    <span className="inline-flex items-center rounded-md bg-indigo-900 text-gray-900 px-2 py-1 text-xs font-medium  ml-4 ">
                                                        Geprüft & Abgenommen
                                                    </span>
                                                </h4>
                                            ):(
                                                <div className={"flex items-center w-full justify-between"}>
                                                    {((element?.status === "active" || element?.status === "completed") && order?.stage !== "inDevelopment") ? (
                                                        <h4 className=' block text-base font-bold text-gray-900'>
                                                            <span>Version {element?.version}</span>
                                                            <span className="inline-flex items-center rounded-md bg-indigo-900/20 px-2 py-1 text-xs font-medium text-gray-600 ml-4 ">
                                                                Zur Abnahme
                                                            </span>
                                                        </h4>
                                                    ):(
                                                        <h4 className=' block text-base font-bold text-gray-900'>
                                                            <span>Version {element?.version}</span>
                                                            <span className="inline-flex items-center rounded-md bg-red/20 px-2 py-1 text-xs font-medium text-gray-600 ml-4 ">
                                                                    Abnahme abgelehnt
                                                                </span>
                                                        </h4>
                                                    )}
                                                </div>
                                            )}
                                        </div>

                                        <div className="accordion  ">
                                            {(isOpen === element?.version) && (
                                                <div className="accordion-content lg:px-6 px-4 p-2 ">
                                                    <div key={element?.version}>
                                                        {(element?.status === "active") ? (
                                                            <p className={"text-sm text-gray-600/60 "}>
                                                                Die Bearbeitung Ihres Auftrags wurde abgeschlossen und kann vom Auftraggeber geprüft werden. Wir informieren diesen umgehend.
                                                            </p>
                                                        ):(
                                                            <p className={"text-sm text-gray-600/60 "}>
                                                                Diese Version wurde bereits durch den Auftraggeber abgelehnt.
                                                            </p>
                                                        )}

                                                        <dl>
                                                            <div className="px-4 mt-12  sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                                <dt className="text-sm/6 font-medium text-gray-900 ">Erstellt am</dt>
                                                                <dd className="mt-1 text-sm/6 text-gray-600/60 sm:col-span-2 sm:mt-0">
                                                                    <div className='truncate text-gray-600/60'>
                                                                        {getDatesField(element?.creationDate)}
                                                                    </div>
                                                                </dd>
                                                            </div>
                                                            <div className="px-4  mt-6 pt-6  border-t border-gray-300 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                                <dt className="text-sm/6 font-medium text-gray-900 ">Dokumente zur Abnahme</dt>
                                                                <dd className="mt-1 text-sm/6 text-gray-600/60 sm:col-span-2 sm:mt-0">
                                                                    <div className='truncate text-gray-600/60 min-h-[100px] -mt-6'>
                                                                        <FileContext.Provider className={"wrapper"} value={{order, orderEdit}}>
                                                                            <OrderUploadBidHandler data={[{
                                                                                name: null,
                                                                                fileType: "GML",
                                                                                path:element?.path,
                                                                                orderEdit: false,
                                                                                orderStage: order.stage,
                                                                                isOrder:true,
                                                                                orderId:order?.id,
                                                                                orderCreator:order?.createdByCompany,
                                                                                reviewVersion:element?.creationDate,
                                                                            }]}/>
                                                                        </FileContext.Provider>
                                                                    </div>
                                                                </dd>
                                                            </div>
                                                            {(true) && (
                                                                <div className="px-4 my-4 border-t border-gray-300 -mt-6 pt-6  sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                                    <dt className="text-sm/6 font-medium  mb-2 text-gray-900 ">Abnahme Protokoll</dt>
                                                                    <dd className="mt-1 text-sm/6 text-gray-600/60 sm:col-span-2 sm:mt-0">
                                                                        <Tasks data={{id:element?.reviewId} }/>
                                                                    </dd>
                                                                </div>
                                                            )}
                                                        </dl>

                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
